import { Page, useCurrent } from "./common";
import { PageHead } from "../components/ui";
import { BudgetStudio } from "../components/BudgetStudio";
import { useCan } from "../lib/auth";

/* The first real conversation on any project: what can be built for this money.
   The studio sets the rate, the client moves the budget, and the brief is shown
   fitting — or not fitting — inside the result. */
export default function CostBrief() {
  const p = useCurrent();
  const canEdit = useCan("estimator");
  if (!p) return null;
  return (
    <Page>
      <PageHead kicker={`${p.name} · ${p.code}`} title="Construction budget" />
      <p className="muted reveal" style={{ maxWidth: 680, marginBottom: 22 }}>
        A preliminary construction cost — what the building is likely to cost at our rates, how much you can build for a
        given budget, and what actually fits inside it. It sets the basis for the design fee, and it's an estimate for
        sizing decisions, not a quotation.
      </p>
      {canEdit
        ? <BudgetStudio p={p} mode="studio" />
        : <div className="card pad reveal"><p className="muted" style={{ fontSize: 14 }}>You don't have access to the fee and budget figures on this project.</p></div>}
    </Page>
  );
}
